import { createApp} from 'vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import App from './App.vue'
import 'gaia-components-vue3/dist/style.css'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import 'font-awesome/css/font-awesome.min.css';
import titleMixin from './mixins/titleMixin';


const app = createApp(App)
const accessToken = localStorage.getItem('access_token')
app.config.globalProperties.$http = axios
if(accessToken) {
    app.config.globalProperties.$http.defaults.headers.common['Authorization'] = accessToken
}


app.config.productionTip = false

app.use(store)
app.use(router, axios)
app.use(Toast)
app.mixin(titleMixin)
app.mount('#app')